import { AwardsGallery } from './AwardsGallery';

const awardsGallery = document.querySelectorAll('.awards-gallery');

awardsGallery.forEach((element) => {
    new AwardsGallery(element);
});
